import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

import { useLocation, useNavigate } from 'react-router';
import { InfoDialogMenu } from './InfoDialogMenu';
import { InfoPages } from './InfoPages';
import { Chapter } from './Chapter';
import { selectInfoModalChapter } from '../../../routes/selector';
import { closeInfoModal, setActiveInfoModalChapterNew } from '../../../routes/actions';
import SplitDialog from '@rio-cloud/rio-uikit/SplitDialog';

const INFO_DIALOG_TITLE_ID = 'intl-msg:infoDialog.title';

// SplitDialog forwards headerButtons to Dialog, but its published props omit it.
const SplitDialogWithHeaderButtons = SplitDialog as React.ComponentType<
    React.ComponentProps<typeof SplitDialog> & { headerButtons?: React.ReactNode }
>;

export const InfoModal = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const chapter = selectInfoModalChapter({ location });
    const handleClose = () => closeInfoModal({ location, push: navigate });

    const handleSelectChapter = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        const selectedChapter = event.currentTarget.getAttribute('data-name');
        if (selectedChapter) {
            setActiveInfoModalChapterNew(selectedChapter, navigate, location);
        }
    };

    return (
        <SplitDialogWithHeaderButtons
            show={Boolean(chapter)}
            title={<FormattedMessage id={INFO_DIALOG_TITLE_ID} />}
            headerButtons={
                <Button
                    bsStyle={Button.MUTED}
                    iconOnly
                    iconName='remove'
                    autoTrackingKey={`${INFO_DIALOG_TITLE_ID.replace('intl-msg:', '')}.close`}
                    onClick={handleClose}
                    aria-label='Close dialog'
                />
            }
            leftContent={<InfoDialogMenu chapter={chapter ?? Chapter.WELCOME} onSelectChapter={handleSelectChapter} />}
            rightContent={chapter ? <InfoPages chapter={chapter} /> : <React.Fragment />}
            onClose={handleClose}
            showCloseButton={false}
            bsSize={'lg'}
        />
    );
};
